import { useState } from 'react';
import { ConfirmDialog } from '../common';

interface DeleteTeamSectionProps {
  teamName: string;
  onDelete: () => Promise<void>;
}

export function DeleteTeamSection({ teamName, onDelete }: DeleteTeamSectionProps) {
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="card bg-base-100 border-error/20">
      <div className="card-body">
        <h2 className="card-title text-lg text-error">Danger Zone</h2>
        <div className="flex justify-between items-center mt-2">
          <div>
            <p className="text-sm font-medium">Delete team</p>
            <p className="text-xs text-base-content/70">
              Deletes {teamName} and removes every member. Its projects aren&apos;t deleted — each
              reverts to a personal project owned by whoever created it.
            </p>
          </div>
          <button className="btn btn-outline btn-error btn-sm" onClick={() => setShowConfirm(true)}>
            Delete Team
          </button>
        </div>
      </div>

      <ConfirmDialog
        isOpen={showConfirm}
        title="Delete team"
        message={`This permanently deletes "${teamName}" and removes all members and pending invites. Its projects will revert to personal projects owned by their creators. This can't be undone.`}
        confirmText="Delete team"
        variant="danger"
        onConfirm={async () => {
          setShowConfirm(false);
          await onDelete();
        }}
        onCancel={() => setShowConfirm(false)}
      />
    </div>
  );
}
